import React from 'react'
import styles from './add-school-form.styles'
import injectSheet from 'react-jss'
import FormWrapper from '../../../../../../form-wrapper/form-wrapper'
import FormHolder from '../../../../../../form-holder/form-holder'
import FormRow from '../../../../../../form-row/form-row'
import FormLabel from '../../../../../../form-label/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Footer from '../../../../../../footer/footer'
import Button from 'pobble-components/dist/button'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useRegisterTeacher } from '../../helpers'

const AddSchoolForm = ({ classes }) => {
  const { registerTeacher, pending } = useRegisterTeacher()
  return (
    <FormWrapper>
      <Formik
        onSubmit={values => registerTeacher(values)}
        initialValues={{
          name: '',
          phone: '',
          email: '',
          website: '',
          address: ''
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Please provide the name of your school'),
          email: Yup.string().email(
            'Provide valid email address please or just leave it empty'
          ),
          website: Yup.string().required(
            'Please provide a website of your school'
          ),
          address: Yup.string().required(
            'Please provide an address of your school'
          ),
          phone: Yup.string().required(
            'Please provide a phone number of your school'
          )
        })}>
        {formikProps => {
          const {
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            touched,
            errors,
            isValid
          } = formikProps
          return (
            <form onSubmit={handleSubmit}>
              <FormHolder>
                <FormRow>
                  <FormLabel htmlFor="name" required>
                    Name of your school
                  </FormLabel>
                  <FormInput
                    center
                    id="name"
                    placeholder="e.g. Pobble"
                    name="name"
                    validationError={touched.name && errors.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="phone" required>
                    Your school's phone number
                  </FormLabel>
                  <FormInput
                    validationError={touched.phone && errors.phone}
                    center
                    id="phone"
                    placeholder="e.g. 01234 567 890"
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="email" required>
                    Your school's email
                  </FormLabel>
                  <FormInput
                    center
                    id="email"
                    placeholder="e.g. email@yourschool.com"
                    validationError={touched.email && errors.email}
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="website" required>
                    Your school's website
                  </FormLabel>
                  <FormInput
                    validationError={touched.website && errors.website}
                    center
                    id="website"
                    placeholder="e.g. www.yourschool.com"
                    name="website"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.website}
                  />
                </FormRow>
                <FormRow>
                  <FormLabel htmlFor="address" required>
                    Your school's address
                  </FormLabel>
                  <FormInput
                    validationError={touched.address && errors.address}
                    center
                    id="address"
                    placeholder="e.g. 43 Gloucester Cres"
                    name="address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address}
                  />
                </FormRow>
              </FormHolder>
              <Footer dense>
                <Button
                  pending={pending}
                  className="metrics__fsu-as-teacher metrics__join-as-teacher-new-school"
                  disabled={!isValid}
                  type="submit"
                  tall
                  wide>
                  Join
                </Button>
              </Footer>
            </form>
          )
        }}
      </Formik>
    </FormWrapper>
  )
}

export default injectSheet(styles)(AddSchoolForm)
